import * as Sentry from "@sentry/react";

import { reload_order_list_all, api_order_type } from "../http/OrderConn";
import {
  customer_list,
  kitchens_list,
  select_shop_setting,
  program_use_list,
  pay_free_yntype,
  notice_list,
  shop_encryption,
  fn_setting_config,
  fn_shop_info,
  fn_setting_prit_receipt,
  fn_agency_holiday_search,
  fn_return_fail,
} from "../http/SettingConn";
import { fn_bridge_load_shop, fn_bridge_shopinfo_set } from "./FnPosBridge";
import { select_access_token } from "../http/TokenConn";
import { search_dlv_Maninfo, search_dlv_store_info } from "../http/dlvCommonConn";
import { origin_info_item } from "http/DetailConn";
import { fn_select_quick_addr } from "./FnBodySetting";
import { fn_rabbitmq_stomp } from "./FnRabbitMqStomp";
import { load_menu_data } from "../http/MenuConn";
import { fn_delivery_call_not_check } from "./FnBodyStep";
import { baerminUseYn, baeminUsePosNo } from "utils/Utils";

// 최초 1회만 조회
export async function fn_init_info(rootStore) {
  try {
    const load_yn = await fn_bridge_load_shop(rootStore);
    if (load_yn === "load_err") {
      console.error("fn_bridge_load_shop: 브릿지 로드에 실패했습니다.");
      return; // 실패 시 함수를 중단
    }

    rootStore.searchStore.setCurrStepType("all");
    await select_access_token(rootStore, false);

    Sentry.setUser({
      username: rootStore.searchStore.getShopCd,
      id: rootStore.searchStore.getPosNo,
    });

    await select_shop_setting(rootStore);
    const configRes = await fn_setting_config(rootStore, "init");

    if (!configRes) {
      console.error("fn_setting_config: 설정 구성에 실패했습니다.");
      return; 
    }

    // 모든 작업이 끝날 때까지 대기
    await Promise.all([
      fn_bridge_shopinfo_set(rootStore),
      fn_select_quick_addr(rootStore),
      reload_order_list_all(rootStore),
      load_menu_data(rootStore),
      search_dlv_Maninfo(rootStore),
      api_order_type(rootStore),
      shop_encryption(rootStore),
      kitchens_list(rootStore),
      customer_list(rootStore),
      program_use_list(rootStore),
      pay_free_yntype(rootStore),
      notice_list(rootStore, "1"),
      origin_info_item(rootStore),
      fn_setting_prit_receipt(rootStore, "HALL"),
      search_dlv_store_info(rootStore).then(() => {
        if (rootStore.layerStore.getLayerDeliveryCallView === true) {
          fn_delivery_call_not_check(rootStore, rootStore.viewStore.getOrderDetail.mobileOrderNo);
        }
      }),
    ]);

    await fn_shop_info(rootStore);
    
    if (rootStore.settingStore.getYgyUseStatus === "Y") {
      const holidayRes = await fn_agency_holiday_search(rootStore);
      if (holidayRes) {
        localStorage.setItem("holidayPop", "hide");
      }
      await fn_return_fail(rootStore);
    }

    if (
      baerminUseYn(rootStore) &&
      (baeminUsePosNo(rootStore) || rootStore.settingStore.getMainPosType === "Y")
    ) {
      await fn_return_fail(rootStore);
    }

    const client = fn_rabbitmq_stomp(rootStore);
    rootStore.rabbitMqStore.setClient(client);
    rootStore.layerStore.setManagerAuthView("manager", localStorage.getItem("auth"));

  } catch (error) {
    console.error("fn_init_info 함수 실행 중 오류가 발생했습니다:", error);
    Sentry.captureException(error);
  }
}